export var HEADER_HEIGHT = '74px';
export var HEADER_HEIGHT_MOBILE = '71px';
export var FOOTER_HEIGHT = '466px';
export var FOOTER_HEIGHT_MOBILE = '147px';
export var SMALL_FOOTER_HEIGHT = '94px';
export var DASHBOARD_NAVBAR_WIDTH = 284;
export var DASHBOARD_CONTENT_WRAPPER_WIDTH = 408;
export var CUSTOMIZATION_CONTENT_COLUMN_MAX_WIDTH = '438px';
export var INPUT_FIELD_HEIGHT = '50px';
export var PROJECT_PAGE_NAVBAR_WIDTH = '228px';
export var STREAMING_BACKDROP_BG = 'rgba(41, 42, 43, 0.6)';
export var LEFTBAR_TOP_PADDING = "30px";
export var LEFTBAR_BOTTOM_PADDING = "34px";
export var SHOW_MOBILE_HEADER_BREAKPOINT = 769;
export var MOBILE_NAVIGATION_DROPDOWN_HEIGHT = '70px';
export var MY_VIDEOS_HEADER_HEIGHT = '143px';